import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

const PHOTOS = [
  { src: "reception", label: "Reception & lounge" },
  { src: "iv-lounge", label: "IV therapy lounge" },
  { src: "iv-suite", label: "IV recliners" },
  { src: "treatment-room", label: "Treatment room" },
  { src: "shop", label: "Wellness shop" },
  { src: "drink-menu", label: "Drink menu" },
  { src: "exterior", label: "Our clinic" },
];

export const ClinicGallery = () => {
  const [open, setOpen] = useState(null);
  return (
    <div className="mb-24" data-testid="clinic-gallery">
      <div className="mb-8">
        <div className="overline">Inside Restore</div>
        <h2 className="font-display text-3xl lg:text-4xl text-sage-800 mt-3">Our clinic</h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
        {PHOTOS.map((p, i) => (
          <button key={p.src} type="button" onClick={() => setOpen(p)} data-testid={`gallery-photo-${p.src}`}
            className={`group relative overflow-hidden rounded-3xl bg-sage-100 aspect-[3/4] ${i === 0 ? "lg:row-span-2 lg:aspect-auto" : ""}`}>
            <img src={`/images/clinic/${p.src}.jpg`} alt={p.label} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            <span className="absolute inset-x-0 bottom-0 p-4 text-left text-white text-sm bg-gradient-to-t from-sage-800/75 to-transparent opacity-90 group-hover:opacity-100 transition-opacity">{p.label}</span>
          </button>
        ))}
      </div>
      <Dialog open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent className="max-w-md p-0 overflow-hidden rounded-3xl border-0" data-testid="gallery-lightbox">
          <DialogTitle className="sr-only">{open?.label}</DialogTitle>
          {open && <img src={`/images/clinic/${open.src}.jpg`} alt={open.label} className="w-full max-h-[85vh] object-cover" />}
          <div className="px-5 py-4 text-sage-800 font-display text-lg">{open?.label}</div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
